export default class GravityFormsValidator {
    constructor({
        el = document.querySelector('.c-form'),
        fieldSelector = '.gfield',
        button = '.gform_button',
        formValidationFieldSelector = '.gform_validation_container',
        requiredOnly = true
    } = {}) {
        this.formContainer = el;
        this.form = el ? el.querySelector('form') : null;
        this.fieldSelector = fieldSelector;
        this.formButton = el ? el.querySelector(button) : null;
        this.validationFieldSelector = formValidationFieldSelector;
        this.requiredOnly = requiredOnly;
        this.inputTypes = ['input', 'select', 'textarea'];
        this.targets = {
            recaptcha: '.ginput_recaptcha',
            required: '.gfield_contains_required',
            validationError: '.gform_validation_error'
        };
        this.classes = {
            active: 'is-active',
            error: 'gfield_error',
            focused: 'is-focused',
            focusedError: 'is-focused--error'
        };
        this.formSubmitted = false;
        this.formSubmittedWithErrors = false;
        this.fields = this.getFields();

        this.init();
        this.addEventListeners();
    }

    addEventListeners() {
        // this.formButton?.setAttribute('disabled', true);

        this.formContainer.addEventListener('change', () => this.init());

        // Event delegation for focus events
        this.formContainer.addEventListener('focusin', (e) => {
            if (this.isInputElement(e.target)) {
                this.toggleClass(e.target, true);
            }
        });

        this.formContainer.addEventListener('focusout', (e) => {
            if (this.isInputElement(e.target)) {
                this.toggleClass(e.target);
            }
        });

        // Autofill animation detection
        this.formContainer.addEventListener('animationstart', (e) => {
            if (this.isInputElement(e.target) && e.animationName === 'onAutoFillStart') {
                this.formContainer.classList.add('is-autofilling');
            }
        });

        this.formContainer.addEventListener('animationend', (e) => {
            if (this.isInputElement(e.target) && e.animationName === 'onAutoFillCancel') {
                this.formContainer.classList.remove('is-autofilling');
                this.toggleClass(e.target, false);
            }
        });

        const observer = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length) {
                    if (document.querySelector(this.targets.validationError)) {
                        this.handlePostRender();
                    }
                }
            });
        });

        observer.observe(this.formContainer, { childList: true, subtree: true });
    }

    init() {
        this.validateForm();
    }

    handlePostRender() {
        this.fields = this.getFields();
        this.postSubmission();
    }

    postSubmission() {
        this.formSubmitted = true;
        this.validateForm();
    }

    validateForm() {
        const hasErrors = this.formContainer.querySelector(this.targets.validationError);

        if (hasErrors) {
            this.formSubmittedWithErrors = true;
            // this.formButton?.setAttribute('disabled', true);
        }

        const inputs = this.fields.flatMap(field =>
            this.inputTypes.map(inputType => field.querySelector(inputType)).filter(input => input && input.id)
        );

        inputs.forEach(input => this.toggleClass(input));
        const allInputsValid = inputs.every(input => this.checkValue(input));

        if (allInputsValid) {
            // this.formButton?.removeAttribute('disabled');
            this.formButton?.classList.add(this.classes.active);
        } else {
            // this.formButton?.setAttribute('disabled', true);
            this.formButton?.classList.remove(this.classes.active);
        }
    }

    toggleClass(element, isFocused = null) {
        const label = this.getAssociatedLabel(element);
        const hasValue = this.checkValue(element);
        const shouldToggle = isFocused || hasValue;

        if (label) {
            label.classList.toggle(this.classes.focused, shouldToggle);

            if (this.formSubmittedWithErrors && label.closest(this.fieldSelector).classList.contains(this.classes.error)) {
                label.classList.add(this.classes.focusedError);
            }
        }
    }

    getFields() {
        const fields = this.formContainer.querySelectorAll(this.requiredOnly ? this.targets.required : this.fieldSelector);
        return Array.from(fields).filter(field => !field.matches(this.validationFieldSelector));
    }

    getAssociatedLabel(element) {
        const id = element.id;
        if (id) {
            return this.formContainer.querySelector(`label[for="${id}"]`);
        }

        const fieldset = element.closest('fieldset');

        return fieldset ? fieldset.querySelector('legend') : null;
    }

    isInputElement(target) {
        return target.matches(`${this.fieldSelector} input, ${this.fieldSelector} select, ${this.fieldSelector} textarea`);
    }

    checkValue(element) {
        return element.type === 'checkbox' ? element.checked : element.value.trim() !== '';
    }
}
